const ColumnBlockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path fill="#ffd400" d="M1 1h22v22H1z" />
    <path d="M22 2v20H2V2h20m2-2H0v24h24V0z" fill="#333" />
    <path fill="#333" d="M4 4h6v16H4zM14 4h6v16h-6z" />
  </svg>
);

export default ColumnBlockIcon;
